import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MidViewComponent } from './mid-view/mid-view.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { EndComponent } from './end/end.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [MidViewComponent, AboutComponent, ContactComponent, EndComponent],
  declarations: [MidViewComponent, AboutComponent, ContactComponent, EndComponent]
})
export class MidModule { }



// WEBPACK FOOTER //
// P:/Portfolio-angular-master/src/app/mid/mid.module.ts